/**
 * Employee Incident Get Service
 * HTTP operations for single incident detail lookup
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetIncidentDetailOut, IncidentDetail } from '../types';
import { mapIncidentDetailOut } from '../mappers';

/**
 * Service for employee incident detail lookup operations
 */
export class EmployeeIncidentGetService {
  /**
   * Get incident detail by ID
   * GET /v{version}/employees/{employeeId}/attendances/incidents/{incidentId}
   */
  async getDetail(employeeId: number, incidentId: number): Promise<ApiResponse<IncidentDetail>> {
    const endpoint = API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.DETAIL(employeeId, incidentId);
    const response = await apiClient.get<LC_GetIncidentDetailOut>(endpoint);

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    const result = mapIncidentDetailOut(response.data);
    return { ...response, data: result };
  }
}

export const employeeIncidentGetService = new EmployeeIncidentGetService();
